( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '.explore-by-concern' ).forEach( ( component ) => {
        const tabs = component.querySelectorAll( '[data-concern-tab]' );
        const panels = component.querySelectorAll( '[data-concern-panel]' );
        const reducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
        const desktopQuery = window.matchMedia( '(min-width: 1024px)' );
        const $ = window.jQuery;

        let activeIndex = 0;
        let transitionTimer;

        const syncState = () => {
          const isDesktop = desktopQuery.matches;

          tabs.forEach( ( tab ) => {
            const isActive = Number( tab.dataset.concernTab ) === activeIndex;

            tab.classList.toggle( 'is-active', isActive );
            tab.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
            tab.setAttribute( 'aria-expanded', isActive ? 'true' : 'false' );
          } );

          panels.forEach( ( panel, index ) => {
            const isActive = index === activeIndex;
            const inner = panel.querySelector( '.explore-by-concern__panel-inner' );

            panel.classList.toggle( 'is-active', isActive );

            if ( !inner || !$ ) {
              return;
            }

            $( inner ).stop( true, true );

            if ( isDesktop ) {
              $( inner ).removeAttr( 'style' );
            } else {
              $( inner ).toggle( isActive );
            }
          } );
        };

        const handleScreenResize = () => {
          window.clearTimeout( transitionTimer );

          if ( activeIndex < 0 ) {
            activeIndex = 0;
          }

          syncState();
        };

        const activate = ( nextIndex ) => {
          if ( !panels[nextIndex] ) {
            return;
          }

          window.clearTimeout( transitionTimer );

          const nextPanel = panels[nextIndex];
          const isDesktop = desktopQuery.matches;
          const duration = reducedMotion ? 0 : 400;

          if ( !isDesktop && nextIndex === activeIndex ) {
            const nextInner = nextPanel.querySelector( '.explore-by-concern__panel-inner' );

            tabs.forEach( ( tab ) => {
              if ( Number( tab.dataset.concernTab ) === nextIndex ) {
                tab.classList.remove( 'is-active' );
                tab.setAttribute( 'aria-selected', 'false' );
                tab.setAttribute( 'aria-expanded', 'false' );
              }
            } );

            if ( $ && nextInner ) {
              $( nextInner ).stop( true, true ).slideUp( duration, () => {
                nextPanel.classList.remove( 'is-active' );
              } );
            } else {
              nextPanel.classList.remove( 'is-active' );
            }

            activeIndex = -1;
            return;
          }

          if ( isDesktop && nextIndex === activeIndex ) {
            return;
          }

          const previousPanel = activeIndex >= 0 ? panels[activeIndex] : null;

          tabs.forEach( ( tab ) => {
            const isActive = Number( tab.dataset.concernTab ) === nextIndex;

            tab.classList.toggle( 'is-active', isActive );
            tab.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
            tab.setAttribute( 'aria-expanded', isActive ? 'true' : 'false' );
          } );

          if ( !isDesktop && $ ) {
            const nextInner = nextPanel.querySelector( '.explore-by-concern__panel-inner' );

            if ( previousPanel ) {
              const previousInner = previousPanel.querySelector( '.explore-by-concern__panel-inner' );

              if ( previousInner ) {
                $( previousInner ).stop( true, true ).slideUp( duration, () => {
                  previousPanel.classList.remove( 'is-active' );
                } );
              } else {
                previousPanel.classList.remove( 'is-active' );
              }
            }

            nextPanel.classList.add( 'is-active' );

            if ( nextInner ) {
              $( nextInner ).stop( true, true ).hide().slideDown( duration );
            }

            activeIndex = nextIndex;
            return;
          }

          if ( previousPanel ) {
            previousPanel.classList.remove( 'is-active' );
          }

          const swapPanel = () => {
            window.requestAnimationFrame( () => nextPanel.classList.add( 'is-active' ) );
            activeIndex = nextIndex;
          };

          if ( reducedMotion ) {
            swapPanel();
          } else {
            transitionTimer = window.setTimeout( swapPanel, 220 );
          }
        };

        tabs.forEach( ( tab ) => {
          tab.addEventListener( 'click', () => activate( Number( tab.dataset.concernTab ) ) );
        } );

        if ( desktopQuery.addEventListener ) {
          desktopQuery.addEventListener( 'change', handleScreenResize );
        } else {
          desktopQuery.addListener( handleScreenResize );
        }

        syncState();
      } );
    },

    finalize: function() {},
  };
  app.registerComponent( 'explore-by-concern', COMPONENT );
} )( app );
